/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StoryImport } from './routes/story'
import { Route as RsvpImport } from './routes/rsvp'
import { Route as PresentationImport } from './routes/presentation'
import { Route as GalleryImport } from './routes/gallery'
import { Route as AdminImport } from './routes/admin'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const StoryRoute = StoryImport.update({
  id: '/story',
  path: '/story',
  getParentRoute: () => rootRoute,
} as any)

const RsvpRoute = RsvpImport.update({
  id: '/rsvp',
  path: '/rsvp',
  getParentRoute: () => rootRoute,
} as any)

const PresentationRoute = PresentationImport.update({
  id: '/presentation',
  path: '/presentation',
  getParentRoute: () => rootRoute,
} as any)

const GalleryRoute = GalleryImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRoute,
} as any)

const AdminRoute = AdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminImport
      parentRoute: typeof rootRoute
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryImport
      parentRoute: typeof rootRoute
    }
    '/presentation': {
      id: '/presentation'
      path: '/presentation'
      fullPath: '/presentation'
      preLoaderRoute: typeof PresentationImport
      parentRoute: typeof rootRoute
    }
    '/rsvp': {
      id: '/rsvp'
      path: '/rsvp'
      fullPath: '/rsvp'
      preLoaderRoute: typeof RsvpImport
      parentRoute: typeof rootRoute
    }
    '/story': {
      id: '/story'
      path: '/story'
      fullPath: '/story'
      preLoaderRoute: typeof StoryImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/presentation': typeof PresentationRoute
  '/rsvp': typeof RsvpRoute
  '/story': typeof StoryRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/presentation': typeof PresentationRoute
  '/rsvp': typeof RsvpRoute
  '/story': typeof StoryRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/gallery': typeof GalleryRoute
  '/presentation': typeof PresentationRoute
  '/rsvp': typeof RsvpRoute
  '/story': typeof StoryRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/admin' | '/gallery' | '/presentation' | '/rsvp' | '/story'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/gallery' | '/presentation' | '/rsvp' | '/story'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/gallery'
    | '/presentation'
    | '/rsvp'
    | '/story'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  GalleryRoute: typeof GalleryRoute
  PresentationRoute: typeof PresentationRoute
  RsvpRoute: typeof RsvpRoute
  StoryRoute: typeof StoryRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  GalleryRoute: GalleryRoute,
  PresentationRoute: PresentationRoute,
  RsvpRoute: RsvpRoute,
  StoryRoute: StoryRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin",
        "/gallery",
        "/presentation",
        "/rsvp",
        "/story"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin": {
      "filePath": "admin.tsx"
    },
    "/gallery": {
      "filePath": "gallery.tsx"
    },
    "/presentation": {
      "filePath": "presentation.tsx"
    },
    "/rsvp": {
      "filePath": "rsvp.tsx"
    },
    "/story": {
      "filePath": "story.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
